<template>
  <validation-observer v-slot="{ invalid }" tag="div" class="modal-user-details">
    <h3>{{ tStatic('missingDetailsModalHeader') }}</h3>

    <div v-html="tStatic('missingDetailsModalText').replace('{name}', clientModel.user.name)"></div>

    <div class="input-column__container">
      <validation-provider v-slot="{errors}" rules="required" slim>
        <oie-base-input-v2
          v-model="details.firstName"
          :errors="errors"
          :label="tStatic('firstNameLabel')"
          :placeholder="tStatic('firstNamePlaceholder')"
          required></oie-base-input-v2>
      </validation-provider>

      <validation-provider v-slot="{errors}" rules="required" slim>
        <oie-base-input-v2
          v-model="details.lastName"
          :errors="errors"
          :label="tStatic('lastNameLabel')"
          :placeholder="tStatic('lastNamePlaceholder')"
          required></oie-base-input-v2>
      </validation-provider>

      <validation-provider v-slot="{errors}" rules="required|mobile:^[0-9+]+$" slim>
        <oie-phone-input
          v-model="details.userPhone"
          :errors="errors"
          :country-code="activeCountry.callingCode"
          required></oie-phone-input>
      </validation-provider>

      <validation-provider
        v-if="isMultiUser && isUserAdmin"
        v-slot="{errors}"
        rules="required|mobile:^[0-9+]+$"
        slim>
        <oie-phone-input
          v-model="details.companyPhone"
          :errors="errors"
          :label="tStatic('phoneCompanyLabel')"
          :placeholder="tStatic('phoneCompanyPlaceholder')"
          :country-code="activeCountry.callingCode"
          required>
        </oie-phone-input>
      </validation-provider>

      <oie-action-wrapper>
        <oie-base-action theme="skeleton" @click="close">
          {{ tStatic('maybeLaterLabel') }}
        </oie-base-action>
        <oie-base-action :disabled="invalid" @click="save">
          {{ tStatic('genericSave') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data() {
    return {
      details: {
        firstName: '',
        lastName: '',
        userPhone: '',
        companyPhone: ''
      }
    }
  },
  computed: {
    activeCountry() {
      return this.clientModel.user.country
    },
    isMultiUser() {
      return this.clientModel.user.isMultiUser
    },
    isUserAdmin() {
      return this.clientModel.user.isUserAdmin
    }
  },
  mounted() {
    // this.details.firstName = this.clientModel.user.firstName
    // this.details.lastName = this.clientModel.user.lastName
    this.details.userPhone = this.clientModel.user.userPhone
    this.details.companyPhone = this.clientModel.user.companyPhone
  },
  methods: {
    async save() {
      await httpService.post('auth/myMissingUserDetails', { ...this.details })

      // this is so that user name in header updates, could probably be done in a better way?
      this.clientModel.user.firstName = this.details.firstName
      this.clientModel.user.lastName = this.details.lastName

      this.publish('modal.hide.user-details')
    },
    close() {
      sessionStorage.setItem('userDetailsModalClosed', true)
      this.publish('modal.hide.user-details')
    }
  }
}
</script>

<style lang="scss">
.modal-user-details {
  display: flex;
  flex-direction: column;
  gap: measure(half);
}
</style>
